// Omnia Route imports
import OMNIAQueues from '../../views/hudportal/queues/view';
import OMNIAContacts from '../../views/hudportal/contacts/view';
import OMNIAActivity from '../../views/hudportal/activity/view';
import OMNIAOperator from '../../views/hudportal/operator/view';
import OMNIACallSummary from '../../views/hudportal/call-summary/view';
import OMNIACallRecordings from '../../views/hudportal/call-recordings/view';
import OMNIAQueueDashboard from '../../views/hudportal/queue-manager-dashboard/view';

import layouts from "../../layout";

export default [
  {
    path: "/omnia/contacts",
    name: "OMNIA Contacts",
    component: OMNIAContacts,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      hudRoute: true,
    },
  },
  {
    path: "/omnia/activity",
    name: "OMNIA Activity",
    component: OMNIAActivity,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      hudRoute: true,
    },
  },
  {
    path: "/omnia/call-summary",
    name: "OMNIA Call Summary",
    component: OMNIACallSummary,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      hudRoute: true,
    },
  },
  {
    path: "/omnia/queues",
    name: "OMNIA Queues",
    component: OMNIAQueues,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      hudRoute: true,
    },
  },
  {
    path: '/omnia/queue-dashboard',
    name: 'OMNIA Queue Manager Dashboard',
    component: OMNIAQueueDashboard,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      hudRoute: true
    }
  },
  {
    path: '/omnia/operator',
    name: 'Omnia Operator Panel',
    component: OMNIAOperator,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      hudRoute: true
    },
  },
  {
    path: "/omnia/call-recordings",
    name: "Omnia Call Recordings",
    component: OMNIACallRecordings,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      hudRoute: true,
    },
  },
];
